import React from 'react';
import Icon from '@components/@core/Icon';
import Initial from './Initial';

const Logo = (props) => {
    const { src, borderColor, borderWidth, onError, onProfile, isSponsored } = props;
    const isIcon = /fa[a-z]\sfa-/.test(src);
    return (
        <div
            className="ds-avatar-logo"
            style={{
                borderColor,
                borderWidth,
                borderStyle: borderWidth > 0 ? 'solid' : 'unset',
            }}
            onClick={onProfile}
        >
            {isIcon || !isSponsored ? (
                <div className="icon">
                    <Icon name={src} size={40} color="#969faa" />
                </div>
            ) : (
                <img src={src} width="100%" height="100%" onError={onError} />
            )}
        </div>
    );
};

export default Logo;
